scrollContainerDownToHere.$inject = ['$timeout', 'ScrollFactory'];
function scrollContainerDownToHere($timeout, ScrollFactory) {
  return {
    restrict: 'E',
    template: '<span></span>',
    scope: {
      topOfContentSelector: '@',
      containerSelector: '@?',
      slightlyAboveActually: '<?'
    },
    link: function (scope, element) {
      // Wait an arbitrary duration for dom rendering
      $timeout(function () {
        const container = scope.containerSelector ? element.closest(scope.containerSelector) 
                                                  : ScrollFactory.mainScrollContainerElement();
        const topOfContent = angular.element(scope.topOfContentSelector);                                        
        const correction =  scope.slightlyAboveActually ? scope.slightlyAboveActually : 0;                                              
        ScrollFactory.scrollContainerToElement(container, topOfContent, element, correction, 500);
      }, 100);
    }
  };
}


/* based on ng-infinite-scroll - v1.0.0 - 2013-02-23,
   but modified to use an arbitrary element as the scroll container (as opposed to the <body> element) 
*/
infiniteScroll.$inject = ['$rootScope', '$timeout', 'ScrollFactory'];
function infiniteScroll($rootScope, $timeout, ScrollFactory) {
  return {
    link: function(scope, elem, attrs) {
      var handler, scrollDistance, scrollEnabled, scrollContainer,
        delayBeforeReEnablingMs, enabledButNotBeforeTimestamp;

      if (attrs.infiniteScrollContainer != null) {
        scrollContainer = angular.element(attrs.infiniteScrollContainer);
      } else {
        scrollContainer = ScrollFactory.mainScrollContainerElement();
      }

      scrollDistance = 0;
      if (attrs.infiniteScrollDistance != null) {
        scrollDistance = parseInt(scope.$eval(attrs.infiniteScrollDistance), 10);
      }
      delayBeforeReEnablingMs = 0;
      if (attrs.infiniteScrollDelayBeforeReEnablingMs != null) {
        delayBeforeReEnablingMs = parseInt(scope.$eval(attrs.infiniteScrollDelayBeforeReEnablingMs), 10);
      }
      enabledButNotBeforeTimestamp = 0;
      scrollEnabled = true;
      if (attrs.infiniteScrollEnabled != null) {
        scope.$watch(attrs.infiniteScrollEnabled, function(value) {
          if (value && delayBeforeReEnablingMs > 0 && enabledButNotBeforeTimestamp === 0) {
            // If configured in the directive, and if are just enabling a disabled scroll,
            // let's set a timestamp that the handler will wait until before actually calling the callback
            // This is to make sure browsers don't trigger scroll events on a not-yet-relaidout/repainted page
            enabledButNotBeforeTimestamp = Date.now() + delayBeforeReEnablingMs;
          } else if (!value) {
            // Reset delay mechanism
            enabledButNotBeforeTimestamp = 0;
          }
          scrollEnabled = value;
        });
      }
      handler = function() {
        // elem.offset().top is negative when the container scrolls down
        var remaining = elem.height() + elem.offset().top - scrollContainer.height();
        var shouldScroll = remaining <= scrollContainer.height() * scrollDistance;
        if (   shouldScroll 
            && scrollEnabled
            && (   enabledButNotBeforeTimestamp === 0
                || Date.now() > enabledButNotBeforeTimestamp)) {

          if ($rootScope.$$phase) {
            scope.$eval(attrs.infiniteScroll);
          } else {
            scope.$apply(attrs.infiniteScroll);
          }
        }
      };
      scrollContainer.on('scroll', handler);
      scope.$on('$destroy', function() {
        scrollContainer.off('scroll', handler);
      });
      $timeout(handler, 0);
    }
  };
}

reverseInfiniteScrollContainer.$inject = [];
function reverseInfiniteScrollContainer() {
  return {
    restrict: 'A',
    scope: {
      enabled: '<',
      scrollDistance: '@',
      loadAction: '&',
    },    
    link: function(scope, element) {

      init();

      function onScroll() {
        const domElement = element[0];
        var shouldScroll = scope.enabled && domElement.scrollTop <= domElement.clientHeight * Number(scope.scrollDistance);
        if (shouldScroll) {
          scope.$apply('loadAction()');
        }
      };

      function init() {
        element.on('scroll.reverseInfiniteScrollContainer', () => onScroll());
        scope.$on('$destroy', () => element.off('scroll.reverseInfiniteScrollContainer'));
      }
    }
  };
}

angular.module('app.scroll-directives', ['app.services'])
  .directive('scrollContainerDownToHere', scrollContainerDownToHere)
  .directive('infiniteScroll', infiniteScroll)
  .directive('reverseInfiniteScrollContainer', reverseInfiniteScrollContainer)
;
